import angular from "angular";

export class AddressRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) { }

    /**
     * @description: 添加地址簿
     * @param {qpmn} addressBookParams
     * @return {*}
     */
    public addAddressBook(addressBookParams: qpmn.user.model.domain.address.IAddToAddressBookParams): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.domain.address.IAddress>> {
        return this.$rest.http<qpmn.user.model.domain.address.IAddress>("addressRestService", "addAddressBook", addressBookParams);
    }

    /**
     * @description: 根据地址簿id查询地址簿
     * @param {number} addressBookId
     * @return {*}
     */
    public searchAddressBookById(addressBookId: number): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.domain.address.IAddress>> {
        return this.$rest.http<qpmn.user.model.domain.address.IAddress>("addressRestService", "searchAddressBookById", {
            addressBookId: addressBookId
        });
    }

    /**
     * @description 根据地址簿id删除地址簿
     * @param {number} addressBookId
     * @return {*}
     */
    public deleteAddressBookById(addressBookId: number): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.domain.address.IAddress>> {
        return this.$rest.http<qpmn.user.model.domain.address.IAddress>("addressRestService", "deleteAddressBookById", {
            addressBookId: addressBookId
        })
    }

    public deleteAddressBooks(addressBookIds: Array<number>): angular.IPromise<qpmn.common.rest.IRestResponse<boolean>> {
        return this.$rest.http<boolean>("addressRestService", "deleteAddressBooks", {
            addressBookIds: addressBookIds
        })
    }

    /**
     * @description 根据地址簿id修改地址簿
     * @param {number} addressBookId
     * @param {qpmn} addressBook
     * @return {*}
     */
    public updateAddressBookById(addressBookId: number, addressBook: qpmn.user.model.domain.address.IUpdateAddressBookParams): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.domain.address.IAddress>> {
        return this.$rest.http<qpmn.user.model.domain.address.IAddress>("addressRestService", "updateAddressBookById", addressBook)
    }

    /**
     * @description: 获取地址簿列表
     * @param {*}
     * @return {*}
     */
    public getAddressBooks(): angular.IPromise<qpmn.common.rest.IRestResponse<Array<qpmn.user.model.domain.address.IAddress>>> {
        return this.$rest.http<Array<qpmn.user.model.domain.address.IAddress>>("addressRestService", "getAddressBooks");
    }


    /**
    * @description 获取默认地址簿
    */
    public getDefaultAddressBook(): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.domain.address.IAddress>> {
        return this.$rest.http<qpmn.user.model.domain.address.IAddress>("addressRestService", "getDefaultAddressBook");
    }
}